import { Component, OnInit, Input } from '@angular/core';
import { SocialService } from '@services/social.service';
import { GlobalService } from '@common/global';
import { ServiceService } from '@services/service.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-social',
  templateUrl: './social.component.html',
  styleUrls: ['./social.component.sass']
})
export class SocialComponent implements OnInit {

  @Input('res') res: object;
  @Input('c') component: string;
  @Input('a') application: string;
  @Input('entityType') entityType: string;
  @Input('socialList') socialList: string;
  @Input('media') media: string;
  @Input('set') set: string;
  @Input('service') service: string;
  @Input('type') type: string;
  action_class: any = {};
  response: any = [];
  isLogin = false;
  id = "";
  constructor(private _service: ServiceService, private _socialService: SocialService, private _global: GlobalService) {

  }


  ngOnInit(): void {
    this.response = this.res;
    this.component = this.component;
    this.application = this.application;
    Object.entries(this.socialList).forEach(([key, value]) => {
      if (value == 'views') {
        this.socialAction('view', 'views');
      }
    });

    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }
    this.id = this.response.id;
    if (this.isLogin && this.service == 'true') {
      let p = {
        'component': this.component,
        'application': this.application,
        'ids': this.id
      };
      this._service.app(p).subscribe(
        sdata => {
          if (!_.isEmpty(this._global.getVal(sdata, 'response', ''))) {
            this.action_class['like'] = this._global.getVal(sdata, 'response.' + this.id + '.like', '');
            this.action_class['dislike'] = this._global.getVal(sdata, 'response.' + this.id + '.dislike', '');
            this.action_class['favorite'] = this._global.getVal(sdata, 'response.' + this.id + '.favorite', '');
            this.action_class['flag'] = this._global.getVal(sdata, 'response.' + this.id + '.flag', '');
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }
  }
  ngOnChanges() {

  }
  social(action, social) {

    if (this._global.isAuthenticated()) {

      this.socialAction(action, social);

    } else {
      this._global.showMessage({ "type": 'info', "message": 'Please login first' });
    }
  }
  socialAction(action, social) {
    let p = {
      "component": this.component,
      "application": this.application,
      "entityId": this._global.getVal(this.response, 'id', ''),
      "action": action,
      "entityType": this.entityType,
      "actionDetails": true
    };
    this._socialService[action](p).subscribe(
      socialView => {
        if (socialView["status"] == "1") {
          if (action != 'view') {
            this.action_class[action] = this._global.getVal(socialView, 'response.' + action, false);
            let message = '';
            message = this._global.getVal(socialView, 'response.message', action + " sucess");
            this._global.showMessage({ "type": 'success', "message": message });
          }
          if (this.media) {
            this.response[social] = this._global.getVal(socialView, 'response.media.' + social, 0);
          } else if (this.set) {
            this.response[social] = this._global.getVal(socialView, 'response.set.' + social, 0);
          } else {
            this.response[social] = this._global.getVal(socialView, 'response.' + this.application + '.' + social, 0);
          } 

        } else {
          if (action != 'view') {
            this._global.showMessage({ "type": 'warning', "message": this._global.getVal(socialView['errors'], 'danger', '') });
          }
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

}
